import { render, staticRenderFns } from "./Bar.vue?vue&type=template&id=450bfcb0&"
import script from "./Bar.vue?vue&type=script&lang=js&"
export * from "./Bar.vue?vue&type=script&lang=js&"
import style0 from "./Bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports